import React  from "react";
import { connect } from "react-redux";
import MyAwards from "./components/MyAwards";

const EmployeeRewards = () => {
  return (
    <div className="space-y-6">
        <MyAwards />
    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeRewards);